/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  readRequest: ["userId"],
  readSuccess: ["response"],
  readFailure: ["response"],
  readOtherRequest: ["userId"],
  readOtherSuccess: ["response"],
  readOtherFailure: ["response"],
  setPushFlags: ["changes"],
  updateRequest: ["changes"],
  updateSuccess: ["response"],
  updateFailure: ["response"],
  updateTouchIdRequest: ["changes"],
  updateTouchIdSuccess: ["response"],
  updateTouchIdFailure: ["error"],
  addAddressRequest: ["address"],
  addAddressSuccess: ["response"],
  addAddressFailure: ["error"],
  updateKargoeCareRequest: ["changes"],
  updateKargoeCareSuccess: ["response"],
  updateKargoeCareFailure: ["error"],
  editDeliveryAddressRequest: ['address'],
  addDeliveryAddressRequest: null,
  resetPassRequest: ["data"],
  resetPassSuccess: ["response"],
  resetPassFailure: ["response"],
  blockUserRequest: ["data"],
  blockUserSuccess: ["response"],
  blockUserFailure: ["response"],
  getBlockUserRequest: ["data"],
  getBlockUserSuccess: ["response"],
  getBlockUserFailure: ["response"],
  outofdate: [""],
  refreshAvatar: [""],
  listFollowingRequest: ['params'],
  listFollowingSuccess: ['response'],
  listFollowingFailure: ['error'],
  listFollowersRequest: ['UserId'],
  listFollowersSuccess: ['response'],
  listFollowersFailure: ['error'],
  getExchangeRates:     [],
  setUserDefaultCurrency: [],
  userSuccess: ["kind", "changes"],
  userFailure: ["kind", "changes"]
})

export const UserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  username: null,
  userId: null,
  otherUserId: null,
  user: null,
  otherUser: null,
  changes: null,
  address: null,
  fetching: null,
  updating: null,
  updatingAddress: null,
  error: null,
  success: null,
  editingAddress: null,
  modified: null,
  blockUser: null,
  blockUserData: null,
  following: [ ], followers: [ ],
  lastModifiedFollowing: 0,
  start: 0,
  nextPage : false,
  outofdate: false,
  refreshAvatar: 0,
  exchangeRates: {
    phase: null, // loading, success, error
    error: null,
    logRef: null,    
    modified: null,
    userCurrency: null,
    rates: null,
    minimumAmount: null,
  },
})

/* ------------- Reducers ------------- */
export const outofdate = ( ) => {
  return state.merge({ outofdate : true })
}
export const refreshAvatar = (state, action) => {
  return state.merge({ refreshAvatar : Math.random() })
}
// read user
export const readRequest = (state, action) => {

  const { userId } = action

  return state.merge({ fetching: true, success: true, updating: false, userId: userId })
}
// read other user
export const readOtherRequest = (state, action) => {

  const { userId } = action

  return state.merge({ fetching: true, success: true, updating: false, otherUserId: userId })
}

// successful read user
export const readSuccess = (state = {}, action) => {

  const { response } = action
  const { data } = response
  const apiResponse = data
  let user = Object.assign({}, apiResponse.data[0])
  if (user.Addresses && user.Addresses.length)
    if (user.Addresses.length <= user.DefaultDelivery)
      user.DefaultDelivery = 0
  return state.merge({ modified: new Date().getTime(), fetching: false, success: true, error: null, username: user.Username, user: user })
}
// successful read other user
export const readOtherSuccess = (state = {}, action) => {

  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]

  return state.merge({ modified: new Date().getTime(), fetching: false, success: true, error: null, otherUser: user })
}
export const blockUserRequest = (state, action) => {

  const { userId } = action

  return state.merge({ fetching: true, blockUser: null })
}

// successful read user
export const blockUserSuccess = (state, action) => {
  const { response: { blockUser } } = action
  console.tron.display({name: `blockUserSuccess redux`,preview :``,value: {state: action}})
  return state.merge({ fetching: false, blockUser: blockUser })
}


export const getBlockUserRequest = (state, action) => {

  const { userId } = action

  return state.merge({ fetching: true, blockUserData: null })
}

// successful read user
export const getBlockUserSuccess = (state, action) => {
  const { response: { data :{data} } } = action


  return state.merge({ fetching: false, blockUserData: data })
}
// reset user
export const resetPassRequest = (state, action) => {



  return state.merge({ fetching: true, success: false, })
}

// successful reset pass
export const resetPassSuccess = (state = {}, action) => {

  const { response } = action
  const { data } = response


  return state.merge({ fetching: false, success: true })
}

// failed reset pass
export const resetPassFailure = (state, action) => {
  const { response } = action


  return state.merge({ fetching: false, error: null, success: false })
}
// failed read user
export const readFailure = (state, action) => {
  const { response } = action


  return state.merge({ modified: new Date().getTime(), fetching: false, error: null, success: false })
}
// failed read other user
export const readOtherFailure = (state, action) => {
  const { response } = action


  return state.merge({ modified: new Date().getTime(), fetching: false, error: null, success: false })
}
export const blockUserFailure = (state, action) => {

  return state.merge({ fetching: false, blockUser: null })
}
export const getBlockUserFailure = (state, action) => {

  return state.merge({ fetching: false, blockUserData: null })
}


// update user
export const updateRequest = (state, action) => {
  const { changes } = action
  const { UserId } = changes
  let userChanges = {}
  userChanges[UserId] = changes
  return state.merge({ fetching: true, success: false, updating: true, changes: userChanges })
}

// successful update user
export const updateSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]
  return state.merge({ success: true, fetching: false, updating: false, error: null, username: user.Username, user: user })
}

// failed save user
export const updateFailure = (state, action) => {
  return state.merge({ success: false, updating: false, error: null, fetching: false })
}


// add Delivery Address
export const addAddressRequest = (state, action) => {

  const { address } = action
  const { UserId } = address
  let userChanges = {}
  userChanges[UserId] = address
  return state.merge({ updatingAddress: true, success: false, address: userChanges })
}

// successful add Address
export const addAddressSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]
  console.tron.display({
    name: 'addAddressSuccess',
    preview: 'expand',
    value: {
      user: user
    }
  })
  return state.merge({ success: true, updatingAddress: false, error: null, username: user.Username, user: user, editingAddress: null })
}

// failed add Address
export const addAddressFailure = (state, action) => {
  return state.merge({ success: false, error: new Error(), updatingAddress: false })
}

//edit address with redux-form
export const editDeliveryAddressRequest = (state, action) => {
  const { address } = action
  return state.merge({ editingAddress: address })
}
export const addDeliveryAddressRequest = (state, action) => {
  return state.merge({ editingAddress: null })
}

/* ------------- TouchID ------------- */
export const updateTouchIdRequest = (state, action) => {
  return state.merge({ user: null, fetching: true })
}
export const updateTouchIdSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]
  return state.merge({ user: user, fetching: false })
}
export const updateTouchIdFailure = (state, action) => {
  const { error } = action
  return state.merge({ error: error ? error : Error(), user: null })
}

/* ------------- Kargoe care ------------- */
export const updateKargoeCareRequest = (state, action) => {
  return state.merge({ user: null, fetching: true })
}
export const updateKargoeCareSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]
  return state.merge({ user: user, fetching: false })
}
export const updateKargoeCareFailure = (state, action) => {
  const { error } = action
  return state.merge({ error: error ? error : Error(), user: null })
}

export const listFollowingRequest = (state, action) => {
  console.tron.display({name: `UserRedux`, preview :`listFollowingRequest`, value: {action: action}})
  const { UserId } = action.params
  return state
}
export const listFollowingSuccess = (state, action) => {
  // const { response : { data : { data } } } = action
  const { response } = action
  const data = response.data.data
  const start = typeof response.data.pagination != 'undefined' && typeof response.data.pagination.start != 'undefined' ? response.data.pagination.start : 0
  const next = typeof response.data.pagination != 'undefined' && typeof response.data.pagination.next != 'undefined' ? response.data.pagination.next : null
  const change = { lastModifiedFollowing: Date.now(), following : data, start: start, nextPage: next }
  console.tron.display({name: `UserRedux`, preview :`listFollowersSuccess`, value: {action: action, change: change}})
  return state.merge(change)
}
export const listFollowingFailure = (state, action) => {
  const { error } = action
  return state.merge({ error : error })
}

export const listFollowersRequest = (state, action) => {
  const { UserId : { UserId, next } } = action
  if( next === false ) return state.merge({ followers : [ ], nextPage : false })
  else return state
}
export const listFollowersSuccess = (state, action) => {
  const { response : { next, data : { data, pagination : { next : nextPage } } } } = action
  const change = { followers : next ? [...state.followers, ...data] : data, nextPage : JSON.stringify(nextPage) }
  return state.merge(change)
}
export const listFollowersFailure = (state, action) => {
  const { error } = action
  return state.merge({ error : error })
}


// modeled after CouponRedux

export const getExchangeRates = (state, action) => {
  const { UserId = null } = action
  console.tron.log(`UserRedux getExchangeRates`);
  const exchangeRates = Object.assign({}, state.exchangeRates, {phase: 'loading', error: null, userCurrency: null, rates: null})
  return state.merge({ exchangeRates })
}

export const setUserDefaultCurrency = (state, action) => {
  console.tron.log(`UserRedux setUserDefaultCurrency`);
  return state
}

const finalizeState = (state, action) => {
  console.tron.display({name: 'userRedux', preview: 'finalizeState', value: { state, action }})
  switch (action.kind) {
    case 'exchangeRates':
      return state.merge({exchangeRates: Object.assign({}, state.exchangeRates, action.changes)})
    default:
      console.tron.log(`Error: unknown action.kind: ${action.kind}`)
  }
  return state.merge({})
}

export const userSuccess = (state, action) => {
  return finalizeState(state, action)
}

export const userFailure = (state, action) => {
  return finalizeState(state, action)
}


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.OUTOFDATE]: outofdate,
  [Types.REFRESH_AVATAR] : refreshAvatar,
  [Types.READ_REQUEST]: readRequest,
  [Types.READ_SUCCESS]: readSuccess,
  [Types.READ_FAILURE]: readFailure,
  [Types.READ_OTHER_REQUEST]: readOtherRequest,
  [Types.READ_OTHER_SUCCESS]: readOtherSuccess,
  [Types.READ_OTHER_FAILURE]: readOtherFailure,
  [Types.SET_PUSH_FLAGS]: updateRequest,
  [Types.UPDATE_TOUCH_ID_REQUEST]: updateTouchIdRequest,
  [Types.UPDATE_TOUCH_ID_SUCCESS]: updateTouchIdSuccess,
  [Types.UPDATE_TOUCH_ID_FAILURE]: updateTouchIdFailure,
  [Types.UPDATE_REQUEST]: updateRequest,
  [Types.UPDATE_SUCCESS]: updateSuccess,
  [Types.UPDATE_FAILURE]: updateFailure,
  [Types.RESET_PASS_REQUEST]: resetPassRequest,
  [Types.RESET_PASS_SUCCESS]: resetPassSuccess,
  [Types.RESET_PASS_FAILURE]: resetPassFailure,

  [Types.ADD_ADDRESS_REQUEST]: addAddressRequest,
  [Types.ADD_ADDRESS_SUCCESS]: addAddressSuccess,
  [Types.ADD_ADDRESS_FAILURE]: addAddressFailure,
  [Types.EDIT_DELIVERY_ADDRESS_REQUEST]: editDeliveryAddressRequest,
  [Types.ADD_DELIVERY_ADDRESS_REQUEST]: addDeliveryAddressRequest,

  [Types.UPDATE_KARGOE_CARE_REQUEST]: updateKargoeCareRequest,
  [Types.UPDATE_KARGOE_CARE_SUCCESS]: updateKargoeCareSuccess,
  [Types.UPDATE_KARGOE_CARE_FAILURE]: updateKargoeCareFailure,

  [Types.BLOCK_USER_REQUEST]: blockUserRequest,
  [Types.BLOCK_USER_SUCCESS]: blockUserSuccess,
  [Types.BLOCK_USER_FAILURE]: blockUserFailure,

  [Types.GET_BLOCK_USER_REQUEST]: getBlockUserRequest,
  [Types.GET_BLOCK_USER_SUCCESS]: getBlockUserSuccess,
  [Types.GET_BLOCK_USER_FAILURE]: getBlockUserFailure,

  [Types.LIST_FOLLOWING_REQUEST]: listFollowingRequest,
  [Types.LIST_FOLLOWING_SUCCESS]: listFollowingSuccess,
  [Types.LIST_FOLLOWING_FAILURE]: listFollowingFailure,
  [Types.LIST_FOLLOWERS_REQUEST]: listFollowersRequest,
  [Types.LIST_FOLLOWERS_SUCCESS]: listFollowersSuccess,
  [Types.LIST_FOLLOWERS_FAILURE]: listFollowersFailure,
  
  [Types.GET_EXCHANGE_RATES]: getExchangeRates,
  [Types.SET_USER_DEFAULT_CURRENCY]: setUserDefaultCurrency,
  [Types.USER_SUCCESS]: userSuccess,
  [Types.USER_FAILURE]: userFailure,
})
